import axios from 'axios';
import { ensureAdminSession, refreshAdminSession } from './adminSession';

const SERVER = (process.env.REACT_APP_SERVER || '').replace(/\/$/, '');

// 로그인이 필요한 관리자 API 호출용. 토큰을 붙이고, 401이면 한 번 재발급 후 재시도한다.
// 재발급까지 실패하면 세션이 지워지고 RequireAdmin이 로그인 화면으로 보낸다.
export const adminApi = axios.create({ baseURL: SERVER, withCredentials: true, timeout: 45000 });

adminApi.interceptors.request.use(async config => {
    const session = await ensureAdminSession();
    if (!session) throw new axios.Cancel('ADMIN_LOGIN_REQUIRED');
    config.headers.Authorization = `Bearer ${session.accessToken}`;
    return config;
});

adminApi.interceptors.response.use(undefined, async error => {
    const config = error.config;
    if (error.response?.status !== 401 || !config || config._retried) throw error;
    config._retried = true;
    const session = await refreshAdminSession();
    if (!session) throw error;
    config.headers.Authorization = `Bearer ${session.accessToken}`;
    return adminApi.request(config);
});

export const SERVER_ERROR_MESSAGE = '서버에 문제가 생겼어요. 잠시 후 다시 시도해주세요.';

// 관리자 API 실패를 화면에 보여줄 문구로 바꾼다. 서버가 문구(error 또는 message)를 주면 그대로 쓴다.
export function toAdminErrorMessage(error, notFoundMessage) {
    const status = error.response?.status;
    if (status === 404 && notFoundMessage) return notFoundMessage;
    if (status === 403) return '이 기능을 사용할 권한이 없습니다.';
    const data = error.response?.data;
    return data?.error || data?.message || SERVER_ERROR_MESSAGE;
}
